import React, {
  useEffect,
  useMemo,
  Fragment,
  forwardRef,
  useState,
  useRef,
} from "react";
import { useServiceStore } from "store";
import { GRAINS, pixelPerInch } from "constants/appConstant";
import Wrapper from "./headwall-components/wrapper";
import { HorizontalRuler, HospitalBed } from "components";
import { alterImageUrl } from "config/calculations/calculation";
import { SlideDoorIcon } from "assets/images";

// const doorPosition = {
//   right: "hidden_right_door",
//   left: "hidden_left_door",
// };

const doorOffsets = {
  24: 390,
  32: 520,
  48: 808,
  64: 1093,
};

const HiddenHeadwall = forwardRef((props, ref) => {
  const {
    values,
    ruler,
    handleDragStart,
    handleonDragOver,
    handleDrop,
    handleDragEnter,
    dragEntered,
    wallLength,
    service,
    clickArrowRight,
    clickArrowLeft,
    showBedGraphic,
  } = props;

  const { serv, view_only, setService } = useServiceStore();

  const { headwalls, width, ceiling_height, model, add_rail, sub_model } =
    values;

  const wrapperRef = useRef(null);
  const [customEvent, setCustomEvent] = useState(null);
  const [railInd, setRailInd] = useState(0);
  //adding some extra pixels in outer div to handle scroll issue while for left and right chase
  const widthCaluclation = useMemo(() => {
    let totalWidth = 0;
    if (sub_model === "single")
      totalWidth = Math.round(width.in / pixelPerInch) + 300;
    else totalWidth = Math.round(width.in / pixelPerInch);
    return totalWidth * 2;
  }, [width, sub_model]);

  //chase width calculation
  const railWidth = useMemo(() => {
    return Math.round((width.ft * 12 + width.in - 4) / pixelPerInch);
  }, [width]);

  const serviceWidth = (ser) => {
    return ser.width / pixelPerInch;
  };

  const servicePosition = (ser) => {
    if (ser?.is_slide && ser.name === "Rail Mounted")
      return `translate(${ser.positions?.x}px, ${90}px)`;
    else return `translate(${ser.positions?.x}px, ${0}px)`;
  };

  const generateStyle = (ser) => {
    const styleObj = {
      cursor: "grab",
      background:
        ser === serv
          ? view_only
            ? "rgba(207, 35, 35, 0.2)"
            : "transparent"
          : "transparent",
    };
    const isSafari =
      /Safari/.test(navigator.userAgent) &&
      /Apple Computer/.test(navigator.vendor);
    if (isSafari) {
      styleObj.left = ser.positions.x;
      styleObj.top = ser?.is_slide ? "80px" : "0px";
    } else styleObj.transform = servicePosition(ser);
    return styleObj;
  };

  const wallHeight = useMemo(() => {
    return Math.round(
      (ceiling_height.ft * 12 + ceiling_height.in) / pixelPerInch
    );
  }, [ceiling_height]);

  useEffect(() => {
    //to adjust scale for axiom
    // Select all elements with the class 'scale'
    if (ruler) {
      const firstElements = document.querySelector(".first");
      const nextElements = document.querySelectorAll(".next");

      // Update styles for 'first' elements
      firstElements.style.maxWidth = "220.285714285px";

      nextElements.forEach((element) => {
        element.style.maxWidth = "214.285714285px";
      });
      // Cleanup function to revert styles when component unmounts
      return () => {
        firstElements.style.maxWidth = "";
        nextElements.forEach((element) => {
          element.style.maxWidth = "";
        });
      };
    }
  }, [ruler, width]);

  const handleKeyDown = (e) => {
    switch (e.key) {
      case "ArrowUp":
        break;
      case "ArrowDown":
        break;
      case "ArrowLeft":
        view_only && clickArrowLeft(customEvent, serv, railInd, 0, "infinity");
        break;
      case "ArrowRight":
        view_only && clickArrowRight(customEvent, serv, railInd, 0, "infinity");
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    let isDragging = false;

    const handleClickOutside = (e) => {
      const clickedInsideFlexItemsEnd = e.target.closest(
        ".flex.items-end".split(" ").join(".")
      );
      if (
        !isDragging &&
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target) &&
        clickedInsideFlexItemsEnd == null
      ) {
        setService("", false);
      }
    };

    const handleDragStart = () => (isDragging = true);
    const handleDragEnd = () => (isDragging = false);

    window.addEventListener("keydown", handleKeyDown);
    document.addEventListener("mousedown", handleClickOutside); // fixed
    document.addEventListener("dragstart", handleDragStart);
    document.addEventListener("dragend", handleDragEnd);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("mousedown", handleClickOutside); // match above
      document.removeEventListener("dragstart", handleDragStart);
      document.removeEventListener("dragend", handleDragEnd);
    };
  }, [serv, view_only]);

  const rulerWidth = useMemo(() => {
    const totalInches = width.in;

    // Convert total inches to feet and inches
    const feet = Math.floor(totalInches / 12);
    const inches = totalInches % 12;

    return { ft: feet, in: inches };
  }, [width]);

  return (
    <>
      <Wrapper
        ruler={ruler}
        width={widthCaluclation}
        wallHeight={wallHeight}
        wallLength={wallLength}
        railWidth={railWidth}
        ceiling_height={ceiling_height}
        model={model}
        ref={ref}
      >
        {/* <div className={`h-full flex justify-center `}> */}
        <div className="h-full flex relative justify-center">
          <div
            className={`flex flex-col h-full relative justify-end w-full`}
            style={{
              width: width.in / pixelPerInch,
            }}
          >
            <>
              <Fragment>
                <div
                  className={`w-max hidden_headwall rail_center relative`}
                  onDragEnter={handleDragEnter}
                >
                  <div className={`flex flex-col gap-[44.6428571429px]`}>
                    {/* door */}
                    {sub_model !== "double" ? (
                      <div
                        className={`hidden_slide hidden_door`}
                        style={{
                          backgroundImage: `url(${SlideDoorIcon})`,
                          [add_rail === "left" ? "right" : "left"]:
                            doorOffsets[width.in],
                          backgroundSize: "contain",
                          backgroundColor: "#A8A599",
                          backgroundPosition: "center",
                        }}
                      />
                    ) : (
                      <>
                        <div
                          className={`hidden_slide hidden_door`}
                          style={{
                            backgroundImage: `url(${SlideDoorIcon})`,
                            right: doorOffsets[width.in],
                            width: width.in / 2 / pixelPerInch,
                            backgroundSize: "contain",
                            backgroundColor: "#A8A599",
                            backgroundPosition: "center",
                          }}
                        />
                        <div
                          className={`hidden_slide  hidden_door`}
                          style={{
                            backgroundImage: `url(${SlideDoorIcon})`,
                            left: doorOffsets[width.in],
                            width: width.in / 2 / pixelPerInch,
                            backgroundSize: "contain",
                            backgroundColor: "#A8A599",
                            backgroundPosition: "center",
                          }}
                        />
                      </>
                    )}
                    {/* ----------------- */}
                    {headwalls?.map((rail, railIndex) => (
                      <div
                        key={railIndex}
                        className={`relative h-[89.2857142857px] flex w-full`}
                        style={{
                          backgroundColor: rail?.color,
                          width: railWidth,
                          backgroundImage: `url(${GRAINS[rail?.background]})`,
                        }}
                        onDrop={(e) => handleDrop(e, "rail", railIndex)}
                        onDragOver={(e) => handleonDragOver(e, "rail")}
                      >
                        {rail.services.map((ser, serviceIndex) => (
                          <Fragment key={serviceIndex}>
                            <div
                              draggable={true}
                              draggableid={ser._id}
                              className={`service_main absolute py-1 flex justify-center h-full items-center ${
                                dragEntered &&
                                !service.service.is_accessory_rail &&
                                !service.service.is_accessory
                                  ? "non_dropable "
                                  : ""
                              }`}
                              style={generateStyle(ser)}
                              onDragStart={(e) =>
                                handleDragStart(ser, e, railIndex, serviceIndex)
                              }
                              onDragEnter={(e) => e.stopPropagation()}
                              onClick={(e) => {
                                // const rect = e.target.getBoundingClientRect();
                                setCustomEvent(e);
                                setService(ser, true);
                                setRailInd(railIndex);
                              }}
                            >
                              <div
                                draggable={"false"}
                                className="service_img pointer-events-none"
                                style={{
                                  width: serviceWidth(ser),
                                  backgroundImage: `url(${alterImageUrl(
                                    ser.image_url
                                  )})`,
                                  backgroundSize: "contain",
                                  backgroundRepeat: "no-repeat",
                                  backgroundPosition: "center",
                                }}
                                onDragEnter={(e) => e.stopPropagation()}
                              />
                            </div>
                          </Fragment>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              </Fragment>

              {ruler && (
                <HorizontalRuler
                  class_name={"w-full bottom-[14px] z-50"}
                  width={rulerWidth}
                />
              )}
            </>
          </div>
        </div>
        {/* </div> */}
        {showBedGraphic && <HospitalBed />}
      </Wrapper>
    </>
  );
});

export default HiddenHeadwall;
